export default __webpack_public_path__ + "static/feature-banner-babymoon-fe7015441c11f701bde5fafcd11a5991.jpg";